import React from 'react';

import Government from './Government.png';
import Shopping from './Shopping.png';
import Art from './Art.png';
import Amusement from './Amusement.png';
import Education from './Education.png';
import Medical from './Medical.png';
import Airport from './Airport.png';
import Restaurant from './Restaurant.png';
import Sights from './Sights.png';
import Stadium from './Stadium.png';
import Metro from './Metro.png';
import Park from './Park.png';




export const markers = {
           Government,
           Shopping,
           Art,
           Amusement,
           Medical,
           Education,
           Restaurant,
           Airport,
           Stadium,
           Metro,
           Park,
           Sights
           
    
};

